/**
 * 匿名ホットライン 1時間あたりの料金（単位: 万）
 */
export const HOTLINE_HOURLY_CONSULTING_FEE = 10;
